import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Format from 'src/Components/Format'

const propTypes = {
  className: PropTypes.string,
  value: PropTypes.number
}

const Rate = ({ className, value, ...restProps }) =>
  value == null ? null : (
    <FormattedMessage
      id='Homeowner.interest.refinance.rate'
      defaultMessage='{rate} Rate'
      values={{
        rate: <Format.Rate value={value} />
      }}
    />
  )

Rate.propTypes = propTypes

export default Rate
